
import { Milestone, MilestoneType } from './types';

export const detectAchievementMilestone = (
  achievements: string[],
  lastAchievementCount: number
): Milestone | null => {
  if (achievements.length > lastAchievementCount) {
    const newAchievement = achievements[achievements.length - 1];
    return {
      title: 'New Achievement!',
      description: newAchievement,
      type: 'achievement'
    };
  }
  return null;
};

export const detectSkillMilestone = (
  skills: any[],
  lastSkillCount: number
): Milestone | null => {
  if (skills.length > lastSkillCount) {
    const newSkill = skills[skills.length - 1];
    return {
      title: 'New Skill Unlocked!',
      description: `You've learned ${newSkill.name}, giving you improved performance.`,
      type: 'skill'
    };
  }
  return null;
};

export const detectYearMilestone = (
  yearsPassed: number,
  lastYearPassed: number
): Milestone | null => {
  if (yearsPassed > lastYearPassed && yearsPassed % 5 === 0) {
    return {
      title: `${yearsPassed} Years Complete!`,
      description: `You've been in the mining industry for ${yearsPassed} years now. Impressive career progress!`,
      type: 'career'
    };
  }
  return null;
};

export const detectKpiMilestones = (
  kpis: Record<string, number>,
  lastKpis: Record<string, number>
): Milestone | null => {
  for (const [key, value] of Object.entries(kpis)) {
    const lastValue = lastKpis[key as keyof typeof kpis];
    const label = key === 'uptime' ? 'Uptime' : 
                  key === 'energyCost' ? 'Energy Cost' :
                  key === 'profitMargin' ? 'Profit Margin' : 'Efficiency';
                  
    // For energyCost, lower is better
    if (key === 'energyCost' && lastValue - value >= 0.02) {
      return {
        title: 'Energy Cost Optimized!',
        description: `You've significantly reduced your energy costs to $${value.toFixed(3)}/kWh.`,
        type: 'kpi'
      };
    } 
    // For other metrics, higher is better
    else if (key !== 'energyCost' && value - lastValue >= 10) {
      return {
        title: `${label} Milestone!`,
        description: `Your ${label.toLowerCase()} has reached an impressive ${value.toFixed(1)}${key === 'profitMargin' || key === 'efficiency' || key === 'uptime' ? '%' : ''}!`,
        type: 'kpi'
      };
    }
  }
  
  return null;
};
